__turbopack_context__.v({
  "error-message": "Error-module-scss-module__BJFs3G__error-message",
  "error-popup": "Error-module-scss-module__BJFs3G__error-popup",
  "error-popup-container": "Error-module-scss-module__BJFs3G__error-popup-container",
  "error-popup-content": "Error-module-scss-module__BJFs3G__error-popup-content",
  "error-popup-header": "Error-module-scss-module__BJFs3G__error-popup-header",
  "error-popup-hide": "Error-module-scss-module__BJFs3G__error-popup-hide",
  "error-popup-inner": "Error-module-scss-module__BJFs3G__error-popup-inner",
});
